import { render, staticRenderFns } from "./PerCategoryTab.vue?vue&type=template&id=87c3bf10&"
import script from "./PerCategoryTab.vue?vue&type=script&lang=js&"
export * from "./PerCategoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports